// extracted by mini-css-extract-plugin
export default {"logoWrapper":"ArLogo_logoWrapper__xy9+2","logoImg":"ArLogo_logoImg__NCfM+"};